import React, { Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import { WEB_PAGES } from "../components";
import { PATH } from "../config";
import PrivateRoute from "./Auth/PrivateRoute";
import { useAuth } from "./Auth/ProvideAuth";
import PublicRoute from "./Auth/PublicRoute";
import { DynamicLoad } from "../assets";
export const RouterConfig = () => {
  const auth = useAuth();
  // console.log("user:::",auth.user)
  return (
    <div>
      <Suspense fallback={<DynamicLoad />}>
        <Switch>
          {/* List all public routes here */}
          <PublicRoute exact path={PATH.LOGIN}>
            <WEB_PAGES.LOGIN />
          </PublicRoute>
          <PublicRoute exact path={PATH.SIGN_UP}>
            <WEB_PAGES.SIGN_UP />
          </PublicRoute>
          <PublicRoute exact path={PATH.FORGOTTONPASSWORD}>
            <WEB_PAGES.FORGOTTONPASSWORD />
          </PublicRoute>
          <PublicRoute exact path={PATH.SETNEWPASSWORD}>
            <WEB_PAGES.SETNEWPASSWORD />
          </PublicRoute>
          <PrivateRoute exact path={PATH.HOME}>
            <WEB_PAGES.HOME />
          </PrivateRoute>
          <PublicRoute exact path={PATH.COMPLETEPROFILE}>
            <WEB_PAGES.COMPLETEPROFILE />
          </PublicRoute>
          {/* <PublicRoute exact path={PATH.HOMEPAGE}>
            <WEB_PAGES.HOMEPAGE />
          </PublicRoute> */}
          <PublicRoute exact path={PATH.HOMEPAGE}>
            <WEB_PAGES.HOMELANDINGPAGE />
          </PublicRoute>
          <PrivateRoute path={PATH.BDPROJECTDATA}>
            <WEB_PAGES.BDPROJECTDATA />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.BDPROJECTAGENTALLOCATION}>
            <WEB_PAGES.BDPROJECTAGENTALLOCATION />
          </PrivateRoute>
          <PrivateRoute path={PATH.ADDSALARY}>
            <WEB_PAGES.ADDSALARY />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.KANBAN}>
            <WEB_PAGES.KANBAN />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.PROJECTWITHTEMPLATE}>
            <WEB_PAGES.PROJECTWITHTEMPLATE />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.NEW_WORK_LOAD}>
            <WEB_PAGES.NEW_WORK_LOAD />
          </PrivateRoute>
          <PrivateRoute path={PATH.MANAGEUSER}>
            <WEB_PAGES.MANAGEUSER />
          </PrivateRoute>
          <PrivateRoute path={PATH.INCOME}>
            <WEB_PAGES.INCOME />
          </PrivateRoute>
          <PrivateRoute path={PATH.DASHBOARD}>
            <WEB_PAGES.DASHBOARD />
          </PrivateRoute>
          <PrivateRoute path={PATH.VIDEOCALL}>
            <WEB_PAGES.VIDEOCALL />
          </PrivateRoute>
          <PrivateRoute path={PATH.EXPENSE}>
            <WEB_PAGES.EXPENSE />
          </PrivateRoute>
          <PrivateRoute path={PATH.PROJECT_TEMPLATE}>
            <WEB_PAGES.PROJECT_TEMPLATE />
          </PrivateRoute>
          <PrivateRoute path={PATH.TEAMSCHEDULER}>
            <WEB_PAGES.TEAMSCHDULER />
          </PrivateRoute>
          <PrivateRoute path={PATH.FINANCE_DASHBOARD}>
            <WEB_PAGES.FINANCE_DASHBOARD />
          </PrivateRoute>
          <PrivateRoute path={PATH.INVOICELIST}>
            <WEB_PAGES.INVOICELIST />
          </PrivateRoute>
          <PrivateRoute path={PATH.NEWINVOICE}>
            <WEB_PAGES.NEWINVOICE />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.SALARY}>
            <WEB_PAGES.SALARY />
          </PrivateRoute>
          <PublicRoute exact path={PATH.UPDATED_LAYOUT}>
            <WEB_PAGES.UPDATED_LAYOUT />
          </PublicRoute>
          <PrivateRoute exact path={PATH.ADDSALARY}>
            <WEB_PAGES.ADDSALARY />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.PROVIDENT_FUND}>
            <WEB_PAGES.PROVIDENTFUND />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.LOANS}>
            <WEB_PAGES.LOANS />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.EMPLOYEE}>
            <WEB_PAGES.EMPLOYEE />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.CASHCATEGORY}>
            <WEB_PAGES.CASHCATEGORY />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.ASSETS}>
            <WEB_PAGES.ASSETS />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.ASSETSALLOCATION}>
            <WEB_PAGES.ASSETSALLOCATION />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.ADDEMPLOYEE}>
            <WEB_PAGES.ADDEMPLOYEE />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.CLIENTS}>
            <WEB_PAGES.CLIENTS />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.DAILYATTENDANCE}>
            <WEB_PAGES.DAILYATTENDANCE />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.ATTENDANCE}>
            <WEB_PAGES.ATTENDANCE />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.LEAVEREQUEST}>
            <WEB_PAGES.LEAVEREQUEST />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.LATECOMING}>
            <WEB_PAGES.LATECOMING />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.USERLIST}>
            <WEB_PAGES.USERLIST />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.DEPARTMENTS}>
            <WEB_PAGES.DEPARTMENTS />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.TEAMS}>
            <WEB_PAGES.TEAMS />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.SUGGESTIONS}>
            <WEB_PAGES.SUGGESTIONS />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.HOLIDAYS}>
            <WEB_PAGES.HOLIDAYS />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.USER_ROLES}>
            <WEB_PAGES.USER_ROLES />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.TRASH}>
            <WEB_PAGES.TRASH />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.FILES}>
            <WEB_PAGES.FILES />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.PROJECTS}>
            <WEB_PAGES.PROJECTS />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.ADDNEWPROJECT}>
            <WEB_PAGES.ADDNEWPROJECT />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.PROJECTMILESTONE}>
            <WEB_PAGES.PROJECTMILESTORE />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.PROJECTSETTING}>
            <WEB_PAGES.PROJECTSETTING />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.WORKLOAD}>
            <WEB_PAGES.NEW_WORK_LOAD />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.MANAGEMENU}>
            <WEB_PAGES.MANAGEMENU />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.VIDEOLINKS}>
            <WEB_PAGES.VIDEOLINKS />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.ORGANIZATION}>
            <WEB_PAGES.ORGANIZATION />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.PROJECTSETTINGS}>
            <WEB_PAGES.PROJECTSETTINGS />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.EVENT}>
            <WEB_PAGES.EVENT />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.FILE_CATEGORY}>
            <WEB_PAGES.FILE_CATEGORY />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.TODO}>
            <WEB_PAGES.TODO />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.BILLABLEHOURS}>
            <WEB_PAGES.BILLABLEHOURS />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.ROLEBASEDMENUS}>
            <WEB_PAGES.ROLEBASEDMENUS />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.MYWORK}>
            <WEB_PAGES.MYWORK />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.REPORTFILES}>
            <WEB_PAGES.REPORTFILES />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.NOTIFICATIONSETTINGS}>
            <WEB_PAGES.NOTIFICATIONSETTINGS />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.NOTICEBOARD}>
            <WEB_PAGES.NOTICEBOARD />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.TEMPLATE}>
            <WEB_PAGES.TEMPLATE />
          </PrivateRoute>

          <PrivateRoute exact path={PATH.FEEDBACKASSIGN}>
            <WEB_PAGES.FEEDBACKASSIGN />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.PRICING}>
            <WEB_PAGES.PRICING />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.PROFILE}>
            <WEB_PAGES.PROFILE />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.USERS_SUMMARY}>
            <WEB_PAGES.USERS_SUMMARY />
          </PrivateRoute>
          <PrivateRoute exact path={PATH.PROJECTS_SUMMARY}>
            <WEB_PAGES.PROJECTS_SUMMARY />
          </PrivateRoute>
          {/* <PrivateRoute exact path={PATH.BUSINESSDEVELOPMENTDASHBOARD}>
          <WEB_PAGES.BUSINESSDEVELOPMENTDASHBOARD />
        </PrivateRoute> */}

          <Route path={PATH.NOPAGE} component={WEB_PAGES.NOPAGE} />
        </Switch>
      </Suspense>
    </div>
  );
};
